<template>
  <a-modal title="选择资源" :visible="visible" width="65%" @ok="handleOk" @cancel="handleCancel" :confirm-loading="confirmLoading">
    <a-form :model="searchForm" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
      <a-row>
        <a-col :span="8">
          <a-form-item label="资源标题">
            <a-input v-model.trim="searchForm.name" v-trim placeholder="请输入资源标题" :maxLength="20" allowClear />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="类型">
            <a-select v-model="searchForm.fileType" placeholder="请选择类型" allowClear>
              <!-- searchFileType: ["文件夹", "文档 ", "图片", "音频", "视频", "压缩文件"], -->
              <a-select-option value="1">文档</a-select-option>
              <!-- <a-select-option value="2">PPT</a-select-option> -->
              <a-select-option value="4">视频</a-select-option>
              <a-select-option value="2">图片</a-select-option>
              <a-select-option value="3">音频</a-select-option>
              <a-select-option value="0">文件夹</a-select-option>
              <a-select-option value="5">压缩文件</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item>
            <a-button type="primary" @click="getPageList(1)">查询</a-button>
            <a-button @click="resetSearch" style="margin-left: 8px">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div>
      <a-row style="margin-bottom: 10px">
        <a-breadcrumb v-if="breadcrumbList.length > 1">
          <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.id">
            <span class="link" @click="handleBreadcrumb(index, item)">{{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-table
        :key="gradeTableRelevant.key"
        :columns="gradeColumns"
        :rowSelection="rowSelection"
        :pagination="gradeTableRelevant.tablePagination"
        row-key="id"
        :scroll="{ y: 400 }"
        :loading="gradeTableRelevant.tableLoading"
        :data-source="gradeTableRelevant.tableDataSource"
        @change="tableChange"
      >
        <div slot="name" class="table-name" slot-scope="text">
          <img :src="$getFileType(text.fileType).icon" style="width: 15px; height: 15px" />
          <a @click="nextFolder(text)" v-if="!text.fileType">{{ text.name }} </a>
          <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
        </div>
        <div slot="type" slot-scope="text">
          {{ searchFileType[text.fileType] }}
          {{ text.fileType === 1 ? `（${suffix(text.fileName)}）` : '' }}
        </div>
        <div slot="size" slot-scope="text">
          {{ text.size > 1024 * 1024 ? (text.size / (1024 * 1024)).toFixed(2) + 'M' : text.size / 1024 < 1 ? (text.size ? text.size + 'B' : '--') : (text.size / 1024).toFixed(2) + 'KB' }}
        </div>
        <div slot="action" slot-scope="text"></div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { FileResource } from '@/utils/http'
export default {
  name: 'SelectSource',
  computed: {
    rowSelection() {
      return {
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectRow.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => v != record.id)
            this.selectRow = this.selectRow.filter((v) => v.id != record.id)
          }
        },
        onSelectAll: (selected, selectedRows, changeRow) => {
          const ids = changeRow.map((v) => v.id)
          if (selected) {
            this.selectedRowKeys.push(...ids)
            this.selectRow.push(...changeRow)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => !(ids.indexOf(v) != -1))
            this.selectRow = this.selectRow.filter((v) => !(ids.indexOf(v.id) != -1))
          }
        },
        // getCheckboxProps: (record) => ({
        //   props: {
        //     disabled: this.selectKeys.indexOf(record.id) !== -1,
        //   },
        // }),
        selectedRowKeys: this.selectedRowKeys,
      }
    },
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: '资源中心',
          id: undefined,
        },
      ],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        {
          title: '资源标题',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '大小',
          scopedSlots: { customRender: 'size' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          sorter: true,
        },
        {
          title: '上传时间',
          dataIndex: 'uploadTime',
          sorter: true,
        },
      ],
      selectedRowKeys: [],
      selectRow: [],
      searchForm: {
        fileType: undefined,
        name: undefined,
      },
      visible: false,
      confirmLoading: false,
    }
  },
  created() {},
  methods: {
    resetSearch() {
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.getPageList(1)
    },
    tableChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.searchForm.sortField = sorter.field
        this.searchForm.sortType = sorter.order === 'descend'
      } else {
        this.searchForm.sortField = undefined
        this.searchForm.sortType = undefined
      }
      this.getPageList()
    },
    showModal(params) {
      return new Promise((resolve, reject) => {
        this.visible = true
        this._resolve = resolve
        this._reject = reject
        this._params = params
        this.gradeTableRelevant.key = Date.now()
        this.getPageList()
      })
    },
    handleOk() {
      if(!this.selectedRowKeys.length){
        return this.$message.error('请选择资源')
      }
      this.visible = false
      this._resolve && this._resolve({ keys: [...this.selectedRowKeys], rows: [...this.selectRow] })
      this.selectRow = []
      this.selectedRowKeys = []
    },
    handleCancel() {
      this.visible = false
      this._reject && this._reject()
      this.selectRow = []
      this.selectedRowKeys = []
      this.breadcrumbList = this.breadcrumbList.slice(0, 1)
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.searchForm = { ...this.searchForm }
    },
    getPageList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        resourcePackageId: this._params.resourcePackageId,
        categoryId: this._params.categoryId,
      }
      if (this.breadcrumbList.length) {
        params.id = this.breadcrumbList.slice(-1)[0].id
      }
      if (params.name || params.fileType !== undefined) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.searchForm.categoryId = []
        params.id = undefined
        params.isAll = !params.id
      }

      this.gradeTableRelevant.tableLoading = true
      FileResource.pagelist(params).then((res) => {
        this.gradeTableRelevant.tableDataSource = res.data.items
        this.gradeTableRelevant.tablePagination.total = res.data.totalCount
        this.gradeTableRelevant.tablePagination.current = res.data.pageIndex
      }).finally(() => {
        this.gradeTableRelevant.tableLoading = false
      })
    },
    nextFolder(record) {
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
      })
      this.$set(this.searchForm, 'fileType', undefined)
      this.$set(this.searchForm, 'name', undefined)
      this.getPageList(1)
    },
    handleBreadcrumb(index, record) {
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      this.getPageList(1)
    },
    suffix(str, point) {
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
  },
}
</script>
<style lang="less" scoped>
.table-name {
  width: 100%;
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
  span {
    display: inline-block;
    word-wrap: break-word;
    word-break: break-all;
  }
}
.link {
  cursor: pointer;
}
</style>
